import { createSliceFunction } from 'cadenza/store/cadenza-store';

export const SLICE_PREFIX = 'workbookSlice'; // exported for testing\
export const slice = createSliceFunction(SLICE_PREFIX);
